import { Component, HostListener, OnInit, ViewChild, Input } from '@angular/core';
import { marker as TRANSLATE } from '@biesbjerg/ngx-translate-extract-marker';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MessageService } from 'primeng/api';
import { ScrollPanel } from 'primeng/scrollpanel';
import * as fromStore from '../../store';
import { Store } from '@ngrx/store';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromFeature from '../../my-features';
import * as moment from 'moment';
import { updateInfoType, GateWaySnmpProfile, CheckDiscoveryJobBySec } from '../../shareModel';
import { RegionService } from 'src/app/services/region.service';
import { UpdateInfoModel } from '../../my-features/updateInfo/update-info.model';
import { Router } from '@angular/router';
import { User } from '../../models/user';
import { PlanSettingParams } from 'src/app/my-features/plan/plan-setting.model';
import { DialogComponent } from '../../../app/dialog/dialog.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  standalone: false,
  selector: 'app-auto-discovery',
  templateUrl: './auto-discovery.component.html',
  styleUrls: ['./auto-discovery.component.css'],
})
export class AutoDiscoveryComponent implements OnInit {
  private componentDestroyed = new Subject();
  UpdateInfoParam = {} as UpdateInfoModel;
  isMsp:boolean = false;
  discoveryJobSettings_columns_cols: any[] = [
    { field: 'jobName', header: TRANSLATE('Discovery Job Name'), width: '200', class: 'col-nowrap ellipsis', disabled: false },
    { field: 'company', header: TRANSLATE('Company'), width: '200', class: 'col-nowrap', disabled: false },
    { field: 'gateway', header: TRANSLATE('Gateway'), width: '200', class: 'col-nowrap', disabled: false },
    { field: '', header: TRANSLATE('IP address'), width: '250', class: 'col-nowrap', disabled: false },
    { field: 'snmp', header: TRANSLATE('SNMP Profile'), width: '250', class: 'col-nowrap ellipsis', disabled: false },
    { field: 'device', header: TRANSLATE('Device Found'), width: '150', class: 'col-nowrap ellipsis', disabled: false },
    { field: 'lastRuntime', header: TRANSLATE('Last Run time'), width: '180', class: 'col-nowrap', disabled: false },
  ];
  discoveryJobSettings = [];
  selectedDiscoveryJob: any = null;
  discoveredDevice_columns_cols: any[] = [
    { field: 'name', header: TRANSLATE('Device Name'), width: '250', class: 'col-nowrap ellipsis', disabled: false },
    { field: 'model', header: TRANSLATE('Model Name'), width: '150', class: 'col-nowrap', disabled: false },
    { field: 'brand', header: TRANSLATE('Brand'), width: '150', class: 'col-nowrap', disabled: false },
    { field: 'category', header: TRANSLATE('Category'), width: '150', class: 'col-nowrap', disabled: false },
    { field: 'ipAddress', header: TRANSLATE('IP address'), width: '150', class: 'col-nowrap', disabled: false },
    { field: 'jobName', header: TRANSLATE('Discovery Job'), width: '200', class: 'col-nowrap ellipsis', disabled: false },
    { field: 'company', header: TRANSLATE('Company'), width: '200', class: 'col-nowrap', disabled: false },
    { field: 'gateway', header: TRANSLATE('Gateway'), width: '200', class: 'col-nowrap', disabled: false },
    { field: 'snmp', header: TRANSLATE('SNMP Profile'), width: '200', class: 'col-nowrap ellipsis', disabled: false },
    { field: 'protocol', header: TRANSLATE('Network Protocol'), width: '200', class: 'col-nowrap ellipsis', disabled: false },
    { field: 'serialNumber', header: TRANSLATE('Serial Number'), width: '200', class: 'col-nowrap', disabled: false },
    { field: 'time', header: TRANSLATE('Time'), width: '180', class: 'col-nowrap', disabled: false },
  ];
  discoveredDevice = [];
  selectedDiscoveredDevice: any = null;
  dialogInput: {
    Id?: number;
    company?: number;
    UpdateType: string;
    jobName: string;
    gateway: any[];
    snmp: any[];
    startIpAddress: string;
    endIpAddress: string;
  };
  displayConfirmDialog = false;
  dialogType = {
    addDiscoveryJob: false,
    addCloudAlert: false,
    stopDiscoveryJobConfirm: false,
    gatewayOfflineWarning: false,
    gatewayUpgradeWarning: false,
  };

  companyOptions: SelectItem[] = [];
  gatewayOptions: SelectItem[] = [];
  profileOptions: SelectItem[] = [];
  categoryOptions: SelectItem[] = [];
  ipAddressPattern = /((^|\.)((25[0-5])|(2[0-4]\d)|(1\d\d)|([1-9]?\d))){4}$/;
  deviceDiscoveryProgress: boolean = false;
  deviceDiscoveryStatus: number = 0;
  runDiscoveryJobList = [];
  scrollPanelHeight: number;
  scrollTopNumer: number;
  stopDiscoveryJobItem:any = [];
  gatewayList = [];
  offlineGatewayArray = [];
  upgradeGatewayArray = [];
  discoveryJobDic = [];
  gatewayDic = [];
  profileDic = [];
  gatewayCategoryDic = [];
  categoryList = [];
  checkIpSaveFlag = false;
  jobNameDuplicate = false;
  checkRunDiscoveryJobListFlag = false;
  intervalId: any = null;
  disableGateWayFlag = false;
  disableProfileFlag = false;
  clickrunDiscoveryJobFlag = false;
  gatewayDicByRegion = [];
  profileDicByRegion = [];
  rgionDic = [];
  params: {
    otp: string;
    RegionIds?: [];
  };
  executingListParams: {
    otp: string;
    RegionIds?: number[];
  };
  editRgionProAuthDic = [];
  mspFilter : any;
  UserParam = {} as User;
  displayDuplicateDeviceSn: boolean = false;
  duplicateDeviceIp: string = "";
  addDeviceList = [];
  discoveryJobRuningFlag: boolean = false;
  clickAddToCloud : boolean = false;
  addToCloudDcodes = [];
  cannotAddToCloud = false;
  @ViewChild('scrollPanel', { static: false }) scrollPanel!: ScrollPanel;
  @ViewChild(DialogComponent, { static: false }) childDialog: DialogComponent;
  constructor(
    private store: Store<fromStore.State>,
    private messageService: MessageService,
    private regionService: RegionService,
    private ngxService: NgxUiLoaderService,
    private translateService: TranslateService,) {

    // Get Msp
    this.store
      .select(fromStore.getIsMsp)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        if (res !== undefined && res !== null) {
          this.isMsp = res;
          this.params = {
            otp: ''
          };
          if (res) {
            let mspRegionIdList = null;
            const mspRegionIdstr = this.regionService.GetRegionIds;
            if (mspRegionIdstr != null && mspRegionIdstr !== undefined && mspRegionIdstr.length > 0) {
              mspRegionIdList = mspRegionIdstr.split(',').map(str => parseInt(str, 10));
            }
            this.params = { ...this.params, RegionIds: mspRegionIdList };
          }
        }
        if (!this.isMsp) {
          this.discoveryJobSettings_columns_cols = this.discoveryJobSettings_columns_cols.filter(col => !(col.field === 'company'));
          this.discoveredDevice_columns_cols = this.discoveredDevice_columns_cols.filter(col => !(col.field === 'company'));
        }
      });

      // Get Category List
      this.store
        .select(fromStore.ReadCategoryList)
        .pipe(takeUntil(this.componentDestroyed))
        .subscribe((res) => {
          if (res !== undefined && res !== null && res.length > 0) {
            this.categoryList = [];
            this.categoryOptions = [];
            [...res].sort(function (a: any, b: any) {
              return a.Value - b.Value;
            }).map((c) => {
              this.categoryList.push(c)
              this.categoryOptions.push({
                label: c.Category, value: c.Value
              })
            })
          }
      });

      combineLatest(this.store.select(fromStore.getRegions), this.store.select(fromStore.getMspMemberAuthority),this.store.select(fromStore.getMspRegionFilter))
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(([region, mspAuth, mspFilter]) => {
        if (region !== undefined && region.length > 0 && mspAuth !== undefined && mspAuth.length > 0 && mspFilter !== null) {
          this.isMsp = mspFilter.isMsp;
          this.mspFilter = mspFilter;
          this.rgionDic = [];
          this.editRgionProAuthDic = [];
          region.map(r => {
            this.rgionDic[r.Id] = r;
          })
          this.companyOptions = [];
          this.companyOptions.push({ label: 'Select Company', value: 0 });
          if (this.rgionDic.length > 0) {
            mspAuth.map((m) => {
              
              if (this.editRgionProAuthDic[m.RegionId] == undefined) {
                this.editRgionProAuthDic[m.RegionId] = {};
                this.editRgionProAuthDic[m.RegionId] = m;
              }

              if (this.rgionDic[m.RegionId] !== undefined && m.EditDevice === 1 && mspFilter.selectedId !== null && mspFilter.selectedId.length > 0 && mspFilter.selectedId.includes(m.RegionId)) {
                this.companyOptions.push({
                  label: this.rgionDic[m.RegionId].RegionName,
                  value: m.RegionId
                })
              }
            })
          }
        }
      });

    combineLatest(this.store.select(fromStore.ReadDiscoveryInfoList), this.store.select(fromStore.ReadProfileList), this.store.select(fromStore.ReadGateWayList)).pipe(takeUntil(this.componentDestroyed))
    .subscribe(([discoveryList, profileList, gateWayList ] ) => {
      if (!profileList.Loading && profileList.Loaded && profileList.entities.length >= 0) {
        this.profileDic = [];
        this.profileOptions = [];
        this.profileDicByRegion = [];
        profileList.entities.map((c) => {
          const optionItem = { label: c.Name, value: c.Id, disabled: false }
          this.profileDic[c.Id] = c;
          this.profileOptions.push(optionItem)
          if (c.RegionId !== undefined) {
            if (this.profileDicByRegion[c.RegionId] === undefined) {
              this.profileDicByRegion[c.RegionId] = [];
            }
            this.profileDicByRegion[c.RegionId].push(optionItem)
          }
        })

      }
      if (!gateWayList.Loading !== undefined && gateWayList.Loaded !== null && Array.isArray(gateWayList.entities) && gateWayList.entities.length >= 0) {
        this.gatewayDic = [];
        this.gatewayOptions = [];
        this.gatewayDicByRegion = [];
        if (!profileList.Loading && profileList.Loaded && profileList.entities.length >= 0) {
          this.gatewayList = gateWayList.entities;
          gateWayList.entities.forEach((g) => {
            this.gatewayDic[g.Id] = g;
            const optionItem = { label: g.Name, value: g.Id, disabled: false }
            // if (g.Status === 1) { // Offline
            //   optionItem.disabled = true;
            // }
            this.gatewayOptions.push(optionItem)
            if (g.RegionId !== undefined) {
              if (this.gatewayDicByRegion[g.RegionId] === undefined) {
                this.gatewayDicByRegion[g.RegionId] = [];
              }
              this.gatewayDicByRegion[g.RegionId].push(optionItem)
            }
          })
        }
      }
      if ((!discoveryList.Loading && discoveryList.Loaded)) {
        if ( Array.isArray(discoveryList.entities) && discoveryList.entities.length > 0) {
          this.getDiscoveryJob(discoveryList.entities);
        } else {
          this.discoveryJobSettings = [];
        }
        // this.ngxService.stop();
      }
    })

    // Get Discovery Info
    this.store.select(fromStore.ReadDiscoveryInfo).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res !== undefined && res !== null) {
        this.checkIpSaveFlag = false;
        this.dialogType.addDiscoveryJob = true;
        this.dialogInput = {
          Id: res.Id,
          UpdateType: 'Edit Discovery Job',
          jobName: res.Name,
          gateway: res.GatewayList,
          snmp: res.ProfileList,
          startIpAddress: res.StartIP,
          endIpAddress: res.EndIP,
          company: res.RegionId
        };
        this.dailogFilter();
      }
    })

    // Execute Discovery List
    this.store.select(fromStore.getExecuteDiscoveryList).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      let stopDispatch = false;
      if (res !== undefined && res !== null) {
        const runDiscoveryJobListDic = [];
        if (this.runDiscoveryJobList.length > 0) {
          this.runDiscoveryJobList.map(r => {
            runDiscoveryJobListDic[r.Id] = r;
          })
        }

        // console.log("ExecutingTime: " + new Date());
        // console.log("response: " + JSON.stringify(res));
        this.runDiscoveryJobList = [];
        if (res.length > 0){
          let changeStatusFlag = false;
          let newExecuteDiscoveryJobList = [];
          this.runDiscoveryJobList = res.map((info) => {
            let disabled = false;
            if (info.RegionId !== undefined) {
              // 沒有編輯權限的gateway只能看不能刪
              if (this.editRgionProAuthDic[info.RegionId] !== undefined) {
                if (this.editRgionProAuthDic[info.RegionId].ViewDevice === 1 && this.editRgionProAuthDic[info.RegionId].EditDevice === 0) {
                  disabled = true;
                }
              }
            }
            let gatewayname: string | undefined;
            if (info.Status == 2) {
              let gateWayNameStr = '';
              if (info.GatewayList !== undefined && info.GatewayList.length > 0) {
                gateWayNameStr = info.GatewayList.map(gid => {
                  if (this.gatewayDic[gid] != undefined) {
                    return this.gatewayDic[gid].Name;
                  }
                }).join(', ');
              }
              gatewayname = gateWayNameStr;
            }
            return {
              ...info,
              status: info.Status,
              ...(disabled ? { disabled: true } : {}),
              ...(gatewayname !== undefined ? { gatewayname } : {}),
            };
          });
          for (var r in this.runDiscoveryJobList) {
            const item = this.runDiscoveryJobList[r];
            if (item !== undefined) {
              const info = item;
              newExecuteDiscoveryJobList.push(item);
              // 確認JobList有無項目,若無的或即可進入判斷
              // 確認JobList每項狀態使否有改變,若有的話才可以更新List
              // 或是其中有包含Excuting中的就持續更新
              if (runDiscoveryJobListDic.length === 0 || runDiscoveryJobListDic[item.Id] === undefined ||
                (runDiscoveryJobListDic[item.Id] !== undefined && (runDiscoveryJobListDic[item.Id].Status !== info.Status || runDiscoveryJobListDic[item.Id].Status === 0))) {
                changeStatusFlag = true;
              }
            }
          }
          if (changeStatusFlag) {
            if (newExecuteDiscoveryJobList !== null && newExecuteDiscoveryJobList.length > 0 ) {
              const executing = newExecuteDiscoveryJobList.filter(s => s.status == 0); // Executing 
              if (executing === undefined || executing.length === 0) {
                this.store.dispatch(new fromFeature.ReadDiscoveryInfoList({ ...this.params }));
                this.store.dispatch(new fromFeature.GetNotifications());
                stopDispatch = true;
              }
              // 即時更新Discovered Device, 不要等到全部更新完才畫
              this.store.dispatch(new fromFeature.ReadDiscoveryResultList({ ...this.params }));
            }
            
            this.runDiscoveryJobList = newExecuteDiscoveryJobList;
            this.runDiscoveryJob(this.runDiscoveryJobList, false);
          } else {
            stopDispatch = true;
          }
        } else {
          stopDispatch = true;
        }
      }
      if (stopDispatch) {
        this.checkRunDiscoveryJobListFlag = false;
        this.stopInterval();
      }
    })
    // Update Info
    this.store.select(fromStore.getUpdateInfoState).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (!res.isLoading && res.isLoaded) {
        if (res.type === updateInfoType.AddDiscoveryInfo || res.type === updateInfoType.UpdateDiscoveryInfo 
          || res.type === updateInfoType.DeleteDiscoveryInfo || res.type === updateInfoType.ExecutingDiscovery 
          || res.type === updateInfoType.StopExecutingDiscovery || res.type === updateInfoType.ConfirmExecutingDiscovery
          || res.type === updateInfoType.AddDeviceToCloud) {
          
          this.messageService.clear();
          if (res.isSaved) {
            // this.store.dispatch(new fromFeature.ReadGatewayList(this.params));
            this.store.dispatch(new fromFeature.ReadDiscoveryInfoList({ ...this.params }));
            this.store.dispatch(new fromFeature.ReadDiscoveryResultList({ ...this.params }));
            if (res.type === updateInfoType.AddDeviceToCloud) {
              this.selectedDiscoveredDevice = null;
              if (this.isMsp) {
                const UserParam = {regionIds: this.mspFilter.selectedId} as User;
                this.store.dispatch(new fromStore.GetDevicesStatusAction(UserParam));
                this.store.dispatch(new fromStore.GetDeviceInfoAction({ regionIds: this.params.RegionIds }));
              } else {
                this.store.dispatch(new fromStore.GetDevicesStatusAction());
                this.store.dispatch(new fromStore.GetDeviceInfoAction());
              }
            }
            if (res.type === updateInfoType.ExecutingDiscovery || res.type === updateInfoType.StopExecutingDiscovery || res.type === updateInfoType.ConfirmExecutingDiscovery) {
              this.selectedDiscoveryJob = null;
              this.store.dispatch(new fromFeature.ExecuteDiscoveryList({ ...this.params }));
              this.checkRunDiscoveryJobListFlag = true
              this.startInterval();
            } else {
              this.messageService.add({ severity: 'success', summary: this.translateService.instant("Success") });
            }
          } else {
            this.messageService.add({ severity: 'error', summary: this.translateService.instant("Failed") });
          }
          this.ngxService.stop();
          this.resetUpdateInfoState();
        }
      }
    })
    
    // Get Discovery Device Result List
    this.store.select(fromStore.ReadDiscoveryResultList).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res !== undefined && res !== null) {
        this.getDiscoveredDevice(res)
      }
    })
    
    // Get Plan Setting Info
    this.store.select(fromStore.getPlanSetting).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (!res.Loading && res.Loaded) {
        if (this.clickAddToCloud && !this.isMsp) {
          let purchasingPlanList = Object.values(res.entities).filter((i) => i.Status !== 2); // no expired.
          purchasingPlanList = purchasingPlanList.map((item) => {
            return { ...item, expirationDate: (item.RemainDay > 0) ? new Date().setDate(new Date().getDate() + item.RemainDay) : 'Expired' };
          });
          const usingPlan = Object.values(purchasingPlanList).find((i) => i.Status === 1);
          let tab = 2;
          if (usingPlan) {
            const dcode_list = [...(Array.isArray(usingPlan.UsingDevices) ? usingPlan.UsingDevices : [])];
            if (this.addToCloudDcodes && this.addToCloudDcodes.length > 0) {
              this.addToCloudDcodes.forEach(i => dcode_list.push(Number(i)));
            }
            const params: PlanSettingParams = {
              PlanInfoId: parseInt(usingPlan.Id, 10),
              dcodes: dcode_list // convert into number.
            };
            if (params.dcodes.length > usingPlan.NodeTotal) {
              tab = 1;
              this.childDialog.addDeviceToCloudRedirect(null , tab);
            } else {
              tab = 0;
              this.childDialog.addDeviceToCloudRedirect(params ,tab);
            }
          } else {
            this.childDialog.addDeviceToCloudRedirect(null ,tab);
          }
          this.clickAddToCloud = false;
        }
      }
    });

    // Get Add To Cloud Device decodes
    this.store
      .select(fromStore.ReadGateWayAddToCloud)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        this.addToCloudDcodes = [];
        if (res !== undefined && !res.Loading && res.Loaded) {
          if (res.entities !== undefined && res.entities !== null && Array.isArray(res.entities)) {
            this.addToCloudDcodes = res.entities.map((e) => ({ ...e }));
            this.store.dispatch(new fromFeature.GetPlanSettings());
          }
        }
      });
  }

  ngOnInit() {
    this.checkRunDiscoveryJobListFlag = true;
    this.dialogType.addDiscoveryJob = false;
    this.initDialogInput();
    this.scrollPanelHeightInit();
    this.startInterval();
  }

  ngAfterViewInit() {
    const scrollContainer = this.scrollPanel.contentViewChild.nativeElement;
    scrollContainer.addEventListener('scroll', () => {
      this.scrollTopNumer = scrollContainer.scrollTop;
    });
    setTimeout(() => {
      this.scrollPanelHeightInit();
    });
  }

  getDiscoveryJob(list) {
    if (list !== undefined && list.length > 0) {
      this.discoveryJobSettings = [];
      this.selectedDiscoveryJob = null;
      this.discoveryJobDic = [];
      const sortedList = [...list].sort(function (a: any, b: any) {
        return b.Id - a.Id;
      });
      
      for (var i in sortedList) { 
        const info = sortedList[i];
        if (info !== undefined) {
          this.discoveryJobDic[info.Id] = info;
          let item = {
            id: info.Id,
            jobName: info.Name,
            gatewayStr: '',
            gateway: info.GatewayList,
            snmpProfileStr: '',
            snmp: info.ProfileList,
            startIpAddress: info.StartIP,
            endIpAddress: info.EndIP,
            device: info.DevicesNumber,
            lastRuntime: info.LastRunTime !== undefined && info.LastRunTime !== null ? moment(Number(info.LastRunTime) * 1000).format('YYYY-MM-DD HH:mm:ss') : '',
            enableRun: info.EnableRun,
            disabledCheckName: true,
            disabledDelete: false,
          } as any;
          if (info.RegionId !== undefined ) {
            // 沒有編輯權限的gateway只能看不能刪
            if (this.editRgionProAuthDic[info.RegionId] !== undefined) {
              if (this.editRgionProAuthDic[info.RegionId].ViewDevice === 1 && this.editRgionProAuthDic[info.RegionId].EditDevice === 0) {
                continue;
              }
            }
            item = {...item, RegionId: info.RegionId, company: this.rgionDic[info.RegionId] !== undefined ? this.rgionDic[info.RegionId].RegionName : '' }
          }
          if (info.GatewayList !== undefined && info.GatewayList.length > 0) {
            const gatewayName = [];
            info.GatewayList.map((g) => {
              if (this.gatewayDic[g] !== undefined) {
                if (this.gatewayDic[g].Status === 0 && this.gatewayDic[g].VersionStatus == 2) {
                  item.disabledDelete = true;
                }
                gatewayName.push(this.gatewayDic[g].Name)
              }
            })
            item.gatewayStr = gatewayName.join(',\r\n');
          }
          if (info.ProfileList !== undefined && info.ProfileList.length > 0) {
            const snmpProfileName = [];
            info.ProfileList.map((p) => {
              if (this.profileDic[p] !== undefined) {
                snmpProfileName.push(this.profileDic[p].Name)
              }
            })
            item.snmpProfileStr = snmpProfileName.join(',\r\n')
          }
          this.discoveryJobSettings.push(item);
        }
      }
      if (this.clickrunDiscoveryJobFlag) {
        this.toggleDiscoveryJobsRunning(this.clickrunDiscoveryJobFlag);
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.scrollPanelHeightInit();
  }

  scrollPanelHeightInit() {
    const element = document.getElementsByClassName('main-title');
    if (element.length > 0) {
      const elementHeight = element[0].clientHeight;
      this.scrollPanelHeight = self.innerHeight - elementHeight - 75;
    }
  }

  initDialogInput() {
    this.dialogInput = {
      UpdateType: 'Add Discovery Job',
      jobName: '',
      gateway: [],
      snmp: [],
      startIpAddress: '',
      endIpAddress: '',
    };
  }

  showAddDialog() {
    this.initDialogInput();
    this.dailogFilter();
    this.dialogType.addDiscoveryJob = true;
  }

  showEditDialog(rowData) {
    const param = {
      otp: '',
      Id: rowData.id
    }
    this.store.dispatch(new fromFeature.ReadDiscoveryInfo(param));
  }

  showConfirmDialog(rowData) {
    this.displayConfirmDialog = true;
    this.dialogInput.Id = rowData.id
  }

  deleteDiscoveryJob() {
    let param = {
      otp: '',
      Id: this.dialogInput.Id
    } 
    this.store.dispatch(new fromFeature.DeleteDiscoveryInfo(param));
    this.displayConfirmDialog = false;
  }

  saveDiscoveryJob() {
    let param = {
      otp: '',
      Name: this.dialogInput.jobName,
      StartIP: this.dialogInput.startIpAddress,
      EndIP: this.dialogInput.endIpAddress,
      GatewayList: this.dialogInput.gateway,
      ProfileList: this.dialogInput.snmp,
      RegionId: this.dialogInput.company,
    } as any
    
    if (this.dialogInput.UpdateType === 'Add Discovery Job') {
      this.store.dispatch(new fromFeature.AddDiscoveryInfo(param));
    } else {
      param.Id = this.dialogInput.Id,
      param.Type = 0, // Job
      this.store.dispatch(new fromFeature.UpdateDiscoveryInfo(param));
    }
    this.dialogType.addDiscoveryJob = false;
  }

  getDiscoveredDevice(devicelist) {
    this.discoveredDevice = [];
    if (devicelist.length > 0) {
      if (!this.isMsp) {
        this.discoveredDevice_columns_cols = this.discoveredDevice_columns_cols.filter(col => !(col.field === 'company'));
      }
      for (var d in devicelist) { 
        const info = devicelist[d];
        
        if (!this.isMsp || (this.isMsp && this.mspFilter.selectedId !== null && this.mspFilter.selectedId.length > 0 && this.mspFilter.selectedId.includes(info.RegionId))) {
          let item = {
            id: info.Id,
            name: info.DeviceName, 
            model: info.Model,
            brand: info.Brand,
            oid: info.OID,
            category: this.categoryList !== undefined && this.categoryList.length > 0 ? this.categoryList.find(s=>s.Value == info.Category) !== undefined ? this.categoryList.find(s=>s.Value == info.Category).Category : '' : '',
            ipAddress: info.IP,
            discoveryId: info.DiscoveryId,
            jobName: this.discoveryJobDic[info.DiscoveryId] !== undefined ? this.discoveryJobDic[info.DiscoveryId].Name : '',
            serialNumber: info.SN,
            time: info.CreateTime !== null ? moment(Number(info.CreateTime) * 1000).format('YYYY-MM-DD HH:mm:ss') : '',
            company: info.RegionId !== undefined ? this.rgionDic[info.RegionId].RegionName : null,
            gatewayId: info.GatewayId,
            gateway: this.gatewayDic[info.GatewayId] !== undefined ? this.gatewayDic[info.GatewayId].Name: '',
            profileId: info.ProfileId,
            protocol: this.profileDic[info.ProfileId] !== undefined ? GateWaySnmpProfile[this.profileDic[info.ProfileId].ProtocolType]: '',
            snmp: this.profileDic[info.ProfileId] !== undefined ? this.profileDic[info.ProfileId].Name: '',
          }
          if (info.RegionId !== undefined ) {
            if (this.editRgionProAuthDic[info.RegionId] !== undefined) {
              // 沒有編輯權限的gateway只能看不能刪
              if (this.editRgionProAuthDic[info.RegionId] !== undefined) {
                if (this.editRgionProAuthDic[info.RegionId].ViewDevice === 1 && this.editRgionProAuthDic[info.RegionId].EditDevice === 0) {
                  continue;
                }
              }
            }
          }
          this.discoveredDevice.push(item);
        }
      }
    }

    this.discoveredDevice = this.discoveredDevice.map(device => ({
      ...device,
      disabledCheckName: true
    }));

    // this.checkDeviceListAll = this.discoveryJobDic.find(s => s.EnableRun == true) ? true : false; 

  }

  onRowSelect($event) {
    $event.data.disabled = false;
  }

  onRowUnselect ($event) {
    $event.data.disabled = true;
  }

  onRowSelectDevice($event) {
    $event.originalEvent.preventDefault();
    const clickbox = true; //打勾
    this.checkBoxTregger($event , clickbox)
    this.replaceDeviceName(clickbox);
  }

  onRowUnselectDevice($event) {
    $event.originalEvent.preventDefault();
    const clickbox = false; //取消勾選
    this.checkBoxTregger($event, clickbox)
    this.replaceDeviceName(clickbox);
  }

  onHeaderCheckboxToggle ($event) {
    
    this.discoveredDevice.forEach(rowData => {
      if ($event.checked === true) {
        rowData.disabledCheckName = false;
      } else if ($event.checked === false) {
        rowData.name = '';
        rowData.disabledCheckName = true;
      }
    });
    this.replaceDeviceName($event.checked);
  }

  replaceDeviceName(clickbox) {
    if (this.selectedDiscoveredDevice !== undefined && this.selectedDiscoveredDevice.length > 0) {
      this.selectedDiscoveredDevice.forEach(item => {
        if (clickbox) {
          if (item.name === '' || item.name === undefined) {
            // 格式為{ModelName}_{IP}的第四碼,長度限制20
            const composition_devicename = item.model + "_" + item.ipAddress.split('.')[3];
            item.name = composition_devicename.substring(0, 20);
          }
        }
      })
    }
  }

  checkAddToCloudDevice() {
    this.cannotAddToCloud = false;
    let deviceEmptyFlag = false;
    this.addDeviceList = [];
    const duplicate = [];
    const addDeviceListDic = [];
    for (let device of this.selectedDiscoveredDevice) {
      if (!device.name || device.name.trim() === '') {
        this.dialogType.addCloudAlert = true;
        deviceEmptyFlag = true;
        return false;
      } else {
        if (addDeviceListDic[device.serialNumber] === undefined) {
          // // test code
          // duplicate.push(device);
          addDeviceListDic[device.serialNumber] = []
        }
        addDeviceListDic[device.serialNumber].push(device);
      }
    }
    for (let device of this.selectedDiscoveredDevice) {
      if (addDeviceListDic[device.serialNumber] !== undefined && addDeviceListDic[device.serialNumber].length > 0) {
        if (addDeviceListDic[device.serialNumber].length > 1) {
          if (duplicate.length === 0 || duplicate.find(s=>s.serialNumber === device.serialNumber) === undefined) {
            duplicate.push(device);
          }
        } else {
          const deviceItem = {
            Id: device.id,
            DeviceName: device.name
          }
          this.addDeviceList.push(deviceItem)
        }
      }
    }
    
    if ( duplicate.length > 0) {
      deviceEmptyFlag = true;
      if (!this.isMsp) {
        this.displayDuplicateDeviceSn = true;
        this.duplicateDeviceIp = duplicate
        .filter(s => s.ipAddress)
        .map(s => `- ${s.ipAddress}`)
        .join("\n");
        if (this.addDeviceList.length == 0 ) {
          this.cannotAddToCloud = true;
        }
      }
    }

    if (!deviceEmptyFlag) {
      this.addToCloud();
    }
    // console.log('addToCloud');
  }

  addToCloud(){
    this.ngxService.start();
    const param = {
      otp: '',
      DeviceList: this.addDeviceList
    }
    if (!this.isMsp) {
      this.clickAddToCloud = true;
    }
    this.store.dispatch(new fromFeature.AddDeviceToCloud(param));
  }

  runDiscoveryJobInit() { 
    if (this.selectedDiscoveryJob !== null && this.selectedDiscoveryJob.length > 0) {
      const newselectedDiscoveryJob = [];
      const newselectedDiscoveryJobDic = [];
      for (const i in this.selectedDiscoveryJob) {
        const item = this.selectedDiscoveryJob[i];
        if (newselectedDiscoveryJobDic[item.id] === undefined) {
          newselectedDiscoveryJobDic[item.id] = item;
          newselectedDiscoveryJob.push(item);
        }
      }
      this.selectedDiscoveryJob = newselectedDiscoveryJob.filter(s=> s.enableRun)
      if (this.selectedDiscoveryJob !== undefined && this.selectedDiscoveryJob.length > 0) {
        this.clickrunDiscoveryJobFlag = true;
        this.checkGatewayStatus(this.selectedDiscoveryJob);
      }
    }
  }

  checkGatewayStatus(items) {
    let offlineGateway = new Set();
    let offlineGatewayName = new Set();
    let upgradeGateway = new Set();
    let upgradeGatewayName = new Set();
    const discoveryList = [];
    const regionIds = [];
    if (items !== null && items.length > 0) {
      items.forEach(item => {
        if (item.RegionId !== undefined) {
          if (regionIds.length > 0) {
            const conatinRegionId = regionIds.find(s=>s === item.RegionId);
            if (!conatinRegionId) {
              regionIds.push(item.RegionId)
            }
          } else {
            regionIds.push(item.RegionId)
          }
        }
        discoveryList.push(item.id);
        item.gateway.forEach(id => {
          let matchedGateway = this.gatewayList.find(gateway => gateway.Id === id);
          if (matchedGateway) { 
            if (matchedGateway.Status === 1) { // Offline
              offlineGateway.add(id);
              offlineGatewayName.add(matchedGateway.Name);
            } else if (matchedGateway.Status === 0 && matchedGateway.VersionStatus == 2) { // UpdateGrade Gateway
              upgradeGateway.add(id);
              upgradeGatewayName.add(matchedGateway.Name);
            }
          }
        })
      }
    );
    this.offlineGatewayArray = Array.from(offlineGatewayName);
    this.upgradeGatewayArray = Array.from(upgradeGatewayName);
      if (this.upgradeGatewayArray.length > 0) {
        this.dialogType.gatewayUpgradeWarning = true;
      } else if (this.offlineGatewayArray.length > 0) {
        this.dialogType.gatewayOfflineWarning = true;
      } else {
        this.executingListParams = {
          otp: '',
          ...(regionIds.length > 0 ? { RegionIds: regionIds } : {}),
        };
        this.reLoadJobStatus(discoveryList, items);
        this.executeDiscovery(discoveryList);
        // this.runDiscoveryJob(items , true);
      }
    }
  }

  runDiscoveryJob(items, executing) {
    if (items !== null && items.length > 0) {
      // this.dialogType.gatewayOfflineWarning = false;
      this.runDiscoveryJobList = items.map((job) => {
        if (executing) {
          return { ...job, status: 0 };
        } else {
          if (this.stopDiscoveryJobItem !== undefined && this.stopDiscoveryJobItem.Id === job.id && job.status !== 0) {
            this.dialogType.stopDiscoveryJobConfirm = false;
          }
          if (job.status !== 2) {
            if (job.status === 0) {
              const percentage = (job.ChkIPNum / job.IPNum) * 100;
              if (percentage < 3) {
                return { ...job, status: job.status, percentage: 0 + percentage + 3 };
              } else {
                return { ...job, status: job.status, percentage: 0 + percentage };
              }
            } else {
              return { ...job, status: job.status };
            }
          } else {
            // RunDiscoveryJob List Gateway Name 
            let gateWayNameStr = "";
            if (job.GatewayList !== undefined && job.GatewayList.length > 0) {
              gateWayNameStr = job.GatewayList.map(gid => {
                if (this.gatewayDic[gid] != undefined) {
                  return this.gatewayDic[gid].Name
                }
              }).join(', ');
            }
            return { ...job, status: job.status, gatewayname: gateWayNameStr};
          }
        }
      });

      const discoveryJobRuningLength = this.runDiscoveryJobList.filter(item => item.status === 0).length > 0;
      if (discoveryJobRuningLength) {
        this.discoveryJobRuningFlag = true;
      } else {
        this.discoveryJobRuningFlag = false;
      }
    }
  }

  toggleDiscoveryJobsRunning(clickRunBtn) {
    const div = document.getElementById('DiscoveryJobsRunning');
    const appMainContent = document.getElementById('appMainContent');
    if (div.classList.contains('show')) {
      // 若Job已經Show出了,再去點擊Run就不隱藏
      if (!clickRunBtn) {
        div.classList.remove('show');
        appMainContent.classList.remove('gateway');
        appMainContent.classList.remove('margin');
        // this.selectedDiscoveryJob = null;
      }
    } else {
      div.classList.add('show');
      appMainContent.classList.add('gateway');
      appMainContent.classList.add('margin');
      this.deviceDiscoveryProgress = true;
    }
  }

  showStopDiscoveryJobConfirm(item) {
    this.selectedDiscoveredDevice = null;
    this.dialogType.stopDiscoveryJobConfirm = true;
    this.stopDiscoveryJobItem = item;
  }

  stopDiscoveryJob() {
    
    this.dialogType.stopDiscoveryJobConfirm = false;
    this.runDiscoveryJobList = this.runDiscoveryJobList.filter(runJob => {
      return runJob.Name !== this.stopDiscoveryJobItem.jobName;
    });
    // this.selectedDiscoveryJob = this.runDiscoveryJobList;

    this.discoveryJobSettings = this.discoveryJobSettings.map(runJob => {
      if (runJob.jobName === this.stopDiscoveryJobItem.jobName) {
        runJob.status = 2;
      }
      return runJob;
    });
    if (this.stopDiscoveryJobItem.Id !== undefined) {
      const param = {
        otp: '',
        Id: this.stopDiscoveryJobItem.Id
      }
      this.store.dispatch(new fromFeature.StopExecutingDiscovery(param));
      this.checkRunDiscoveryJobListFlag = true;
    }
  }

  confirmDiscoveryJob(item) {
    this.runDiscoveryJobList = this.runDiscoveryJobList.filter(runJob => {
      return runJob.jobName !== item.Name;
    });

    this.discoveryJobSettings = this.discoveryJobSettings.map(runJob => {
      if (runJob.jobName === item.Name) {
        runJob.status = null;
      }
      return runJob;
    });

    const param = {
      otp: '',
      Id: item.Id
    }
    this.store.dispatch(new fromFeature.ConfirmExecutingDiscovery(param));
    this.selectedDiscoveredDevice = null;
    this.checkRunDiscoveryJobListFlag = true;
  }

  checkIpAdress(newIp: string, type: string) {
    // 確認前Ip前三組是否相符
    if (type == 'start') {
      this.dialogInput.startIpAddress = newIp;
    } else {
      this.dialogInput.endIpAddress = newIp;
    }
    let startIP = this.dialogInput.startIpAddress.split('.').slice(0, 3).join('.');
    let endIP = this.dialogInput.endIpAddress.split('.').slice(0, 3).join('.');
    // 確認前Ip第四組是否Start小於End
    let startIPLastNumber = parseInt(this.dialogInput.startIpAddress.split('.')[3]);
    let endIPLastNumber = parseInt(this.dialogInput.endIpAddress.split('.')[3]);
    this.checkIpSaveFlag = false;
    if (startIP !== endIP || startIPLastNumber > endIPLastNumber) {
      this.checkIpSaveFlag = true;
    }
  }

  checkJobName() {
    // 確認是否有相同的名稱
    this.jobNameDuplicate = false;
    if (this.discoveryJobSettings !== undefined && this.discoveryJobSettings.length > 0) {
      for (let i = 0; i < this.discoveryJobSettings.length; i++) {
        if (this.discoveryJobSettings[i].jobName === this.dialogInput.jobName) {
          this.jobNameDuplicate = true;
        }
      }
    }
  }

  checkExecuteDiscoveryList() {
    this.store.dispatch(new fromFeature.ExecuteDiscoveryList({ ...this.params }));
  }

  checkAttention() {
    this.toggleDiscoveryJobsRunning(true)
    // this.runDiscoveryJobList = this.selectedDiscoveryJob;
    const selectedDiscoveryItem = this.selectedDiscoveryJob.filter(s=> s.enableRun);
    if (selectedDiscoveryItem !== undefined && selectedDiscoveryItem.length > 0) {
      const discoveryList = [];
      selectedDiscoveryItem.map(a=> {
        discoveryList.push(a.id);
      })
      // this.runDiscoveryJob(selectedDiscoveryItem , true);
      this.reLoadJobStatus(discoveryList, selectedDiscoveryItem);
      this.executeDiscovery(discoveryList);
    }
    this.dialogType.gatewayOfflineWarning = false;
  }

  reLoadJobStatus(discoveryList, selectedDiscoveryItem) {
    this.runDiscoveryJobList = this.runDiscoveryJobList.map((j) => {
      if (discoveryList.includes(j.InfoId)) {
        return { ...j, status: 0 };
      }
      return j;
    });
    this.discoveryJobSettings = this.discoveryJobSettings.map((s) => {
      if (discoveryList.includes(s.id)) {
        return { ...s, enableRun: false };
      }
      return s;
    });
    
    if (selectedDiscoveryItem !== undefined && selectedDiscoveryItem.length > 0) {
      for (const i in selectedDiscoveryItem) {
        const info = selectedDiscoveryItem[i];
        const difaultItem = {
          Name: info.jobName,
          status : 0
        }

        if (this.runDiscoveryJobList.length == 0 || (this.runDiscoveryJobList.length > 0 && this.runDiscoveryJobList.find(s=>s.InfoId == info.id) === undefined)) {
          this.runDiscoveryJobList = [...this.runDiscoveryJobList, difaultItem];
        }
      }
    }
  }
  
  executeDiscovery(discoveryList) {
    const param = {
      otp: '',
      Type: 0, //Job
      DiscoveryList: discoveryList
    }
    this.store.dispatch(new fromFeature.ExecuteDiscovery(param));
  }

  dailogFilter(change : boolean = null) {
    if (!this.isMsp) {
      this.disableGateWayFlag = false;
      this.disableProfileFlag = false;
    } else {
      this.disableGateWayFlag = true;
      this.disableProfileFlag = true;
      if (this.gatewayDicByRegion !== undefined && this.gatewayDicByRegion[this.dialogInput.company] !== undefined) {
        this.gatewayOptions = [];
        this.gatewayOptions = this.gatewayDicByRegion[this.dialogInput.company];
        if (this.dialogInput.gateway.length == 0 || change) {
          this.dialogInput.gateway = this.gatewayDicByRegion[this.dialogInput.company].filter(g=>g.value && !g.disabled).map(g => g.value)
        }
        this.disableGateWayFlag = false;
      } else {
        this.dialogInput.gateway = [];
      }
      if (this.profileDicByRegion !== undefined && this.profileDicByRegion[this.dialogInput.company] !== undefined) {
        this.profileOptions = [];
        this.profileOptions = this.profileDicByRegion[this.dialogInput.company];
        if (this.dialogInput.snmp.length == 0 || change) {
          this.dialogInput.snmp = this.profileDicByRegion[this.dialogInput.company].filter(g=>g.value).map(g => g.value);
        }
        this.disableProfileFlag = false;
      } else {
        this.dialogInput.snmp = [];
      }
    }
  }

  checkBoxTregger (event : any, clickbox : boolean) {
    let result = true;
    const deviceDic = [];
    // 先將所有勾選的Device做成一個Dictionary
    // 因為會將checkbox隱藏起來,所以不會有同樣sn存入的問題
    if ((event && event !== undefined && event !== null) && this.selectedDiscoveredDevice !== undefined){
      if (this.selectedDiscoveredDevice.length > 0) {
        this.selectedDiscoveredDevice.map((s) => {
          if (deviceDic[s.serialNumber] == undefined) {
            deviceDic[s.serialNumber] = s;
          }
        })
      }
    }
    // 跑整個list判斷CheckBox與Name Disabled與否
    if (this.discoveredDevice.length > 0) {
      for (var i in this.discoveredDevice) {
        const item = this.discoveredDevice[i];
        if (deviceDic) {
          // 先保留下方程式,主要是為了勾選checkbox後判斷List內若有其他相同的SN則將他們disable,防止同一個sn重複加入 20250312

          // // 判斷List內跟event同樣的SN沒有被選過
          // if (deviceDic[item.serialNumber] !== undefined) {
          //   // 如果同樣的sn已經有被選過了,則將其他條的checkbox與Name都disable起來
          //   if (deviceDic[item.serialNumber].id !== item.id) {
          //     item.disabledCheckName = true;
          //     item.disabledCheckBox = true;
          //   } else {
          //     // 第一筆被勾選的,所以可以編輯
          //     item.disabledCheckName = false;
          //     item.disabledCheckBox = false;
          //   }
          //   item.disabledCheckName = false;
          //   item.disabledCheckBox = false;
          // } else {
          //   // 不存在於selectDeviceDic內
          //   if (event.data.id === item.id) {
          //     // 判斷是打勾還是取消勾選
          //     // 打勾代表CheckBox與Name都可以編輯
          //     if (clickbox) {
          //       item.disabledCheckName = false;
          //       item.disabledCheckBox = false;
          //     } else {
          //       // 取消代表還原成預設,僅可以勾選而不可以編輯Name
          //       item.name = '';
          //       item.disabledCheckName = true;
          //       item.disabledCheckBox = false;
          //     }
          //   } else {
          //     // 跟click的id不同代表是List內,且未被勾選的其他筆
          //     item.disabledCheckName = true;
          //     item.disabledCheckBox = false;
          //   }
          // }
          if (event.data.id === item.id) {
            // 判斷是打勾還是取消勾選
            // 打勾代表CheckBox與Name都可以編輯
            if (clickbox) {
              item.disabledCheckName = false;
              // item.disabledCheckBox = false;
            } else {
              // 取消代表還原成預設,僅可以勾選而不可以編輯Name
              item.name = '';
              item.disabledCheckName = true;
              // item.disabledCheckBox = false;
            }
          } else {
            // 跟click的id不同代表是List內,且未被勾選的其他筆
            // item.disabledCheckName = true;
            // item.disabledCheckBox = false;
          }
        }
      }
    }
    return result;
  }

  startInterval() {
    if (!this.intervalId) {
      this.intervalId = setInterval(() => {
        if (this.checkRunDiscoveryJobListFlag == true) {
          this.store.dispatch(new fromFeature.ExecuteDiscoveryList({ ...this.params }));
        }
      }, CheckDiscoveryJobBySec * 1000);
      // console.log("計時器已啟動");
    }
  }

  stopInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.checkRunDiscoveryJobListFlag == false
      this.clickrunDiscoveryJobFlag = false;
      this.intervalId = null;
      // console.log("計時器已停止");
    }
  }

  closeAddDiscoveryJobDailog() {
    const div = document.querySelector('.ui-multiselect-panel');
    if (div !== null) {
      div.remove();
    }
  }

  ngOnDestroy(): void {
    this.stopInterval();
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
    const appMainContent = document.getElementById('appMainContent');
    appMainContent.classList.remove('gateway');
    appMainContent.classList.remove('margin');
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromFeature.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
  }
}
